// extracted by mini-css-extract-plugin
export default {"content":"PartnersContent_content__RTDqj","pageTitle":"PartnersContent_pageTitle__Cw3IB"};